import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@mui/material/Modal';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GoogleMapsNew from '../GoogleMapsNew';

const DialogBox = ({ open, onClose, coordinates }) => {
    const handleClose = () => {
        onClose();
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Box
                sx={{
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 1,
                    maxWidth: 1000,
                    width: "100%",
                    maxHeight: "120vh",
                    overflowY: "auto",
                    borderRadius: 2,
                    position: "relative",
                }}
            >
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{ position: "absolute", top: 10, right: 10 }}
                >
                    <CloseIcon />
                </IconButton>

                <Box mt={4}>
                    <GoogleMapsNew coordinatesArray={coordinates} />
                </Box>
            </Box>
        </Modal>
    );
};

DialogBox.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,

    // FIXED: coordinates must be array (GoogleMapsNew receives array)
    coordinates: PropTypes.array.isRequired,
};

export default DialogBox;
